import React, { useEffect, useState } from "react";
import styles from "./EditCategory.module.css";
import step from "../../../assets/step3.png";
import { useLocation, useNavigate } from "react-router-dom";
import InputField from "../../../components/input/InputField";
import Button from "../../../components/button/Button";
import { AntdDropdown } from "../../../components";
import { Form, TimePicker } from "antd";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import AlertAction from "../../../store/Actions/AlertActions";
import CustomerMiddleware from "../../../store/Middlewares/CustomerMiddlewares";
import moment from "moment";

function ShiftDetails() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [form] = Form.useForm();
  const { t, i18n } = useTranslation();
  const { state } = useLocation();
  const data = state;
  console.log("data", data);

  const handleChange = (value) => {
    form.setFieldsValue({ role: value });
  };

  const CategoryList = useSelector(
    (state) => state.CategoriesReducer.CategoryList
  );
  const [SelectedCategory, setSelectedCategory] = useState(data?.category_id);
  const [SelectedDate, setSelectedDate] = useState(data?.date);
  const [SelectedCustomer, setSelectedCustomer] = useState(data?.customer_id);
  const [selectedLocation, setselectedLocation] = useState(data?.location?.id);
  const [SelectedUrgency, setSelectedUrgency] = useState(data?.urgency);
  const [ServiceName, setServiceName] = useState(data?.service_name);
  const [ServiceDetails, setServiceDetails] = useState(data?.details);
  const [InventoryData, setInventoryData] = useState({
    inventory: data?.inventories ? data?.inventories : null,
  });
  const [SelectedCleaner, setSelectedCleaner] = useState(null);
  const [StartTime, setStartTime] = useState(null);
  const [EndTime, setEndTime] = useState(null);
  const [LunchStartTime, setLunchStartTime] = useState(null);
  const [LunchEndTime, setLunchEndTime] = useState(null);
  const [SelectedShift, setSelectedShift] = useState(null);
  const [CustomerList, setCustomerList] = useState([]);
  const [CleanerList, setCleanerList] = useState([]);
  const [currentCleaner, setCurrentCleaner] = useState([]);
  const [Location, setLocation] = useState([]);
  console.log("time", StartTime, EndTime, LunchStartTime, LunchEndTime);

  useEffect(() => {
    getCustomer();
    getCleaner();
    getLanguage();
  }, []);

  const getLanguage = async () => {
    try {
      const language = localStorage.getItem("@selectedLanguage");
      i18n.changeLanguage(language);
    } catch (e) {
      console.log(e);
    }
  };

  const onPressRequest = () => {
    let startTime = StartTime
      ? moment(StartTime, "h:mm:ss A").format("HH:mm:ss")
      : null;
    let endTime = EndTime
      ? moment(EndTime, "h:mm:ss A").format("HH:mm:ss")
      : null;
    let startLunchTime = LunchStartTime
      ? moment(LunchStartTime, "h:mm:ss A").format("HH:mm:ss")
      : null;
    let endLunchTime = LunchEndTime
      ? moment(LunchEndTime, "h:mm:ss A").format("HH:mm:ss")
      : null;
    console.log(
      "onPressRequest",
      startTime,
      endTime,
      startLunchTime,
      endLunchTime
    );
    if (!SelectedCleaner) {
      dispatch(
        AlertAction.ShowAlert({
          type: "error",
          message: "Select cleaner name!",
        })
      );
    } else if (!startTime || !endTime) {
      dispatch(
        AlertAction.ShowAlert({
          type: "error",
          message: "Select START and END time!",
        })
      );
    } else if (startTime >= endTime) {
      dispatch(
        AlertAction.ShowAlert({
          type: "error",
          message: "Start time should be before End time",
        })
      );
    } else if (startLunchTime && !endLunchTime) {
      dispatch(
        AlertAction.ShowAlert({
          type: "error",
          message: "Select Lunch end time!",
        })
      );
    } else if (!startLunchTime && endLunchTime) {
      dispatch(
        AlertAction.ShowAlert({
          type: "error",
          message: "Select Lunch start time!",
        })
      );
    } else if (startLunchTime && startLunchTime >= endLunchTime) {
      dispatch(
        AlertAction.ShowAlert({
          type: "error",
          message: "Lunch end time should be greater than Lunch start time",
        })
      );
    } else if (
      startLunchTime &&
      startLunchTime < startTime ||
      startLunchTime > endTime
    ) {
      dispatch(
        AlertAction.ShowAlert({
          type: "error",
          message: "Lunch start time should be between your job time",
        })
      );
    } else if (
      endLunchTime &&
      endLunchTime < startTime ||
      endLunchTime > endTime
    ) {
      dispatch(
        AlertAction.ShowAlert({
          type: "error",
          message: "Lunch end time should be between your job time",
        })
      );
    }
    // else{
    //   dispatch(
    //     AlertAction.ShowAlert({
    //       type: "error",
    //       message: "created",
    //     })
    //   );
    // }
    else {
      let userdata = {
        WorkOrderRequestId: data?.id,
        SelectedCategory: SelectedCategory,
        SelectedDate: SelectedDate,
        SelectedCustomer: SelectedCustomer,
        selectedLocation: selectedLocation,
        SelectedUrgency: SelectedUrgency,
        ServiceName: ServiceName,
        ServiceDetails: ServiceDetails,
        StoreID: data?.store_id,
        LocationID: data?.store_location_id,
        SelectedInventory: InventoryData?.inventory,
        SelectedCleaner: SelectedCleaner,
        StartTime: StartTime,
        EndTime: EndTime,
        LunchStartTime: LunchStartTime,
        LunchEndTime: LunchEndTime,
        SelectedShift: SelectedShift,
        next_page_url: undefined,
      };
      dispatch(CustomerMiddleware.CreateJob(userdata))
        .then((data) => {
          dispatch(
            AlertAction.ShowAlert({ type: "success", message: data?.message })
          );
          navigate("/contractorHome/Checklist/CreateChecklist", {
            state: { data: userdata, screen: "AcceptWorkOrder", jobData: data },
          });
          // Alert.alert('Note', data?.message, [
          //   { text: 'OK', onPress: () => navigation.navigate('AddCheckList') },
          // ]);
        })
        .catch((error) => console.log(error));
      // navigate('/contractorHome/Checklist/CreateChecklist', { state: { data: userdata, screen: 'AcceptWorkOrder' } })
    }
  };

  const getCustomer = () => {
    let userdata = {
      role: "customer",
    };
    dispatch(CustomerMiddleware.getUsersByRole(userdata))
      .then((resdata) => {
        setCustomerList(resdata?.data);
        getUserLocation(data?.customer_id, resdata?.data);
      })
      .catch((err) => console.log(err));
  };

  const getCleaner = () => {
    let data = {
      role: "cleaner",
    };
    dispatch(CustomerMiddleware.getUsersByRole(data))
      .then((data) => {
        setCleanerList(data?.data);
      })
      .catch((err) => console.log(err));
  };

  const getUserLocation = (id, array) => {
    for (let i = 0; i < array.length; i++) {
      if (id == array[i]?.id) {
        setLocation(array[i]?.addresses);
      }
    }
  };

  console.log('currentCleaner', currentCleaner);


  return (
    <div className={styles.home_mainContainer}>
      <div className={styles.flex}>
        <h1 className={styles.heading}>{t("Edit Job Details")}</h1>
        <img src={step} className={styles.step_image} />
      </div>

      <text className={styles.sub_heading}>{t("Shift Details")}</text>

      <AntdDropdown
        style={{ marginTop: "3%" }}
        name={t("Select Cleaner")}
        placeholder={t("Select Cleaner")}
        label={t("Cleaner Name")}
        // onChange={handleChange}
        // options={[
        //   { value: "cleaner a", option: "cleaner a" },
        //   { value: "cleaner b", option: "Cleaner b" },
        //   { value: "cleaner c", option: "cleaner c" },
        // ]}
        onChange={(val) => {
          setCurrentCleaner(CleanerList.find(data => data.id == val))
          setSelectedCleaner(val)
        }}
        options={CleanerList?.map((item) => {
          return { value: item?.id, option: item?.name };
        })}
      />

      {SelectedCleaner &&
        <div className={styles.flexD}>
          <div className={styles.wrap_input}>
            <text className={styles.sub_heading}>{t("Work Schedule")}</text>
            <p className={styles.sub_heading}>From {moment(currentCleaner.working_start_time, "h:mm:ss A").format('LT')} to {moment(currentCleaner.working_end_time, "h:mm:ss A").format('LT')}</p>
          </div>

          <div className={styles.wrap_input}>
            <text className={styles.sub_heading}>{t("Break Schedule")}</text>
            <p className={styles.sub_heading}>From {moment(currentCleaner.break_time_in, "h:mm:ss A").format('LT')} to {moment(currentCleaner.break_time_out, "h:mm:ss A").format('LT')}</p>

          </div>
        </div>}


      <div className={styles.flexD}>
        <div className={styles.wrap_input}>
          <Form.Item
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            name={"start_time"}
            label={<p className={styles.label_style}>Start Time</p>}
          >
            <TimePicker
              use12Hours
              format="h:mm a"
              className={"datePickerWhiteBordered"}
              placeholder={"Start Time"}
              onChange={(time, timeString) => setStartTime(timeString)}
            />
          </Form.Item>
        </div>

        <div className={styles.wrap_input}>
          <Form.Item
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            name={"end_time"}
            label={<p className={styles.label_style}>End Time</p>}
          >
            <TimePicker
              use12Hours
              format="h:mm a"
              className={"datePickerWhiteBordered"}
              placeholder={"End Time"}
              onChange={(time, timeString) => setEndTime(timeString)}
            />
          </Form.Item>
        </div>
      </div>

      <div className={styles.flexD}>
        <div className={styles.wrap_input}>
          <Form.Item
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            name={"lunch_start_time"}
            label={<p className={styles.label_style}>Lunch Start Time</p>}
          >
            <TimePicker
              use12Hours
              format="h:mm a"
              className={"datePickerWhiteBordered"}
              placeholder={"Lunch Start Time"}
              onChange={(time, timeString) => setLunchStartTime(timeString)}
            />
          </Form.Item>
        </div>

        <div className={styles.wrap_input}>
          <Form.Item
            labelCol={{ span: 24 }}
            wrapperCol={{ span: 24 }}
            name={"lunch_end_time"}
            label={<p className={styles.label_style}>Lunch End Time</p>}
          >
            <TimePicker
              use12Hours
              format="h:mm a"
              className={"datePickerWhiteBordered"}
              placeholder={"Lunch End Time"}
              onChange={(time, timeString) => setLunchEndTime(timeString)}
            />
          </Form.Item>
        </div>
      </div>

      <AntdDropdown
        name={t("Select Shift")}
        label={t("Shift")}
        placeholder={t("Select Shift")}

        onChange={(val) => setSelectedShift(val)}
        options={[
          { value: "Morning", option: t("Morning") },
          { value: "Evening", option: t("Evening") },
        ]}
      />

      <div className={styles.button}>
        <Button text={t("Add Job")} onClick={() => onPressRequest()} />
      </div>
    </div>
  );
}

export default ShiftDetails;
